import React, { useContext, useState, useRef } from 'react';
import { ProjectContext } from '../context/ProjectContext';

export const ProjectDetails = ({ projectItem }) =>  {
    const { dispatch } = useContext(ProjectContext);

    const exit = useRef(null);
    const exit2 = useRef(null);
    const exit3 = useRef(null);
    const created = new Date(projectItem.createdOn);
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const [name, setName] = useState(projectItem.name);
    const [section, setSection] = useState(projectItem.section);
    const [needle, setNeedle] = useState(projectItem.needle);
    const [yarn, setYarn] = useState(projectItem.yarn);
    const [stitchName, setStitchName] = useState(projectItem.stitchName);
    const [rowCount, setRowCount] = useState(projectItem.rowCount);
    const [stitchCount, setStitchCount] = useState(projectItem.stitchCount || 0);
    const [notes, setNotes] = useState(projectItem.notes);

    const handleRowDecrease = () => {
        if (rowCount >= 1){
            setRowCount(rowCount - 1);
            dispatch(
                {type: 'UPDATE_COUNT',
                    project: {
                        id: projectItem.id,
                        name: "rowCount",
                        info: rowCount-1
                    }}
            )
        }
    }

    const handleStitchDecrease = () => {
        if (stitchCount >= 1){
            setStitchCount(stitchCount - 1);
            dispatch(
                {type: 'UPDATE_COUNT',
                    project: {
                        id: projectItem.id,
                        name: "stitchCount",
                        info: stitchCount-1
                    }}
            )
        }
    }

    const handleRowIncrease = () => {
            setRowCount(rowCount + 1);
            dispatch(
                {type: 'UPDATE_COUNT',
                    project: {
                        id: projectItem.id,
                        name: "rowCount",
                        info: rowCount+1
                    }}
            )
    }

    const handleStitchIncrease = () => {
            setStitchCount(stitchCount + 1);
            dispatch(
                {type: 'UPDATE_COUNT',
                    project: {
                        id: projectItem.id,
                        name: "stitchCount",
                        info: stitchCount+1
                    }}
            )
    }

    const handleUpdate = (e) => {
         dispatch(
             {type:'UPDATE_PROJECT', 
             project: {
                 id: projectItem.id, 
                 name: e.target.value, 
                 info: e.target.name}
                })
    }

    const checkTime = (i) => {
        if (i < 10) {i = "0" + i}; 
        return i;
    }

    const handleHover =  () => {
        let children = Array.prototype.slice.call(exit.current.children);
        children.forEach(x => x.style.color = "lightgray");
        let children2 = Array.prototype.slice.call(exit2.current.children);
        children2.forEach(x => x.style.color = "lightgray");
        let children3 = Array.prototype.slice.call(exit3.current.children);
        children3.forEach(x => x.style.color = "lightgray");
    }

    const handleOver = () => {
        let children = Array.prototype.slice.call(exit.current.children);
        children.forEach(x => x.style.color = "black");
        let children2 = Array.prototype.slice.call(exit2.current.children);
        children2.forEach(x => x.style.color = "black");
        let children3 = Array.prototype.slice.call(exit3.current.children);
        children3.forEach(x => x.style.color = "black");
    }
    
    return(
    <section ref={exit} className="Project">
        <button id="close-project" onMouseOver={handleHover} onMouseOut={handleOver} onClick={() => dispatch({type: 'REMOVE_PROJECT', id: projectItem.id})}>X</button>
        <p>{created.getDate()} {months[created.getMonth()]} {created.getFullYear()}</p>
        <p>{checkTime(created.getHours())+":"+checkTime(created.getMinutes())}</p>
        
        <br></br>

        <label htmlFor="name">Project</label>
        <input value={name} onChange={(e) => {setName(e.target.value); handleUpdate(e)}} name="name"></input>

        <label htmlFor="section">Section</label>
        <input value={section} onChange={(e) => {setSection(e.target.value); handleUpdate(e)}} name="section"></input>

        <label htmlFor="needle">Needle Size</label>
        <input value={needle} onChange={(e) => {setNeedle(e.target.value); handleUpdate(e)}} name="needle"></input>

        <label htmlFor="yarn">Yarn</label>
        <input value={yarn} onChange={(e) => {setYarn(e.target.value); handleUpdate(e)}} name="yarn"></input>

        <label htmlFor="stitchName">Stitch</label>
        <input value={stitchName} onChange={(e) => {setStitchName(e.target.value); handleUpdate(e)}} name="stitchName"></input>

        <div ref={exit3} className="Counter">
            <p>Row Counter</p>
            <button className="reset" onClick={() => {setRowCount(0);
             dispatch(
                {type: 'UPDATE_COUNT',
                    project: {
                        id: projectItem.id,
                        name: "rowCount",
                        info: 0
                    }}
            )}}>Reset</button>
            <br></br>
            <button onClick={handleRowDecrease}>-</button>
            <span className="counter">{rowCount}</span>
            <button onClick={handleRowIncrease}>+</button>
        </div>

        <div ref = {exit2} className="Counter">
            <p>Stitch Counter</p>
            <button className="reset" onClick={() => {setStitchCount(0);
             dispatch(
                {type: 'UPDATE_COUNT',
                    project: {
                        id: projectItem.id,
                        name: "stitchCount",
                        info: 0
                    }}
            )}}>Reset</button>
            <br></br>
            <button onClick={handleStitchDecrease}>-</button>
            <span className="counter">{stitchCount}</span>
            <button onClick={handleStitchIncrease}>+</button>
        </div>

        <label htmlFor="notes">Notes</label>
        <textarea value={notes} onChange={(e) => {setNotes(e.target.value); handleUpdate(e)}} className="notes" name="notes"></textarea>
    </section>)
}